<template>
  <div class="s-page">
    <div class="s-tab">
      <div
        class="s-item"
        v-for="(item, index) in tabList"
        :key="item.id"
        @click="handleTab(index)"
        :class="tabIndex == index ? 'active' : ''"
      >
        {{ item.title }}
      </div>
    </div>
    <div class="p-match" v-if="!showList">
      <div class="pm-list" v-if="projectList.length > 0">
        <div
          class="pm-item"
          v-for="(item, index) in projectList"
          :key="index"
          @click="handleMatch(item, index)"
          :class="index % 3 == 2 ? 'no-margin' : ''"
        >
          <div class="pm-bg">
            <img :src="getIconUrl(item.programId)" alt="" />
            <div class="name">{{ item.program }}</div>
          </div>
          <div class="right">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="date" v-if="item.beginTime">
              <a-icon type="history" style="margin-right: 6px;" /> {{ item.beginTime.slice(0, 10) }}~{{
                item.endTime.slice(0, 10)
              }}
            </div>
            <div class="adress"><a-icon type="environment" style="margin-right: 6px;" />{{ item.address }}</div>
          </div>
          <!-- 报名状态 -->
          <div class="status">
            <div class="btn" :style="handleStatusStyle(item, 1)">
              {{ matchFun.statusText(item.status) }}
              <div class="arrows" :style="handleStatusStyle(item, 0)"></div>
            </div>
          </div>
        </div>
      </div>
      <AntdvEmpty v-else desc="暂无比赛项目" :imgHeight="100" />
    </div>
    <div class="p-match" v-else>
      <div class="content">
        <!-- <div class="back"><div class="back-btn" @click="backProgram">返回</div></div> -->
        <div v-if="websitePageMatchList.length > 0" class="match-list">
          <MatchList
            :programType="2"
            :websitePageMatchList="websitePageMatchList"
            v-for="(item, index) in websitePageMatchList"
            :key="index"
            :item="item"
          />
        </div>
        <AntdvEmpty v-else desc="暂无比赛项目" :imgHeight="100" />
      </div>
    </div>
  </div>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
import AntdvEmpty from '@comm/components/public/AntdvEmpty'
import MatchList from '@comm/components/MatchList'
export default {
  props: {},
  components: {
    MatchList,
    AntdvEmpty,
  },
  data () {
    return {
      matchFun,
      tabIndex: 0,
      tabList: [],
      projectList: [],
      showList: false, //是否为多个赛事
      // matchIds:[],//多个赛事列表
      offline: [
        {
          matchIds: [10],
          program: '田径',
          programId: 44,
        },
        {
          matchIds: [10],
          program: '排球',
          programId: 14,
        },
        {
          matchIds: [10],
          program: '篮球',
          programId: 5,
        },
      ], //离线测试数据
      websitePageMatchList: [], //多个赛事活动
    }
  },
  mounted () {
    this.getSeriesGroup()
  },
  methods: {
    handleStatusStyle (item, index) {
      if (index == 0) {
        return {
          'border-top-color': matchFun.statusArrowsColor(item.status),
          'border-left-color': matchFun.statusArrowsColor(item.status),
        }
      } else {
        return { 'background-color': matchFun.statusColor(item.status) }
      }
    },
    getIconUrl (id) {
      try {
        return require(`@daoba-match/assets/darkSportsLogo/w${id}.png`)
      } catch (error) {
        //999为默认图标
        return require('@daoba-match/assets/darkSportsLogo/w999.png')
      }
    },
    handleTab (index) {
      this.tabIndex = index
      this.projectList = this.tabList[this.tabIndex].matchData ? this.tabList[this.tabIndex].matchData : []
      this.showList = false
    },
    handleMatch (item, index) {
      switch (item.programId) {
      case 5:
        this.$router.push({
          name: 'BasketBall',
          query: {
            matchId: item.id,
            isRefresh: 1,
            programId: item.programId,
          },
        })
        break
      case 55:
        this.$router.push({
          name: 'TrackField',
          query: {
            matchId: item.id,
            isRefresh: 1,
            programId: item.programId,
          },
        })
        break
      case 14:
        this.$router.push({
          name: 'VolleyBall',
          query: {
            matchId: item.id,
            isRefresh: 1,
            programId: item.programId,
          },
        })
        break
      default:
        this.$router.push({
          name: 'MatchDetail',
          query: {
            matchId: item.id,
            isRefresh: 1,
            programId: item.programId,
          },
        })
        break
      }
    },
    async getSeriesGroup () {
      try {
        let res = await this.$api.district.seriesGroup()
        if (res.status == 0) {
          //增加本地测试数据
          // res.data[3].matchList=this.offline
          this.tabList = res.data
          this.projectList = res.data[this.tabIndex].matchData
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    //获取多个赛事列表
    async getProgramMatchList (matchIds) {
      try {
        let res = await this.$api.district.programMatchList(matchIds)
        if (res.status == 0) {
          this.websitePageMatchList = res.data
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    backProgram () {
      this.showList = false
    },
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
.s-page {
  width: 100%;
  //导航
  .s-tab {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 130px;
    margin-bottom: 20px;
    .s-item {
      width: 160px;
      height: 46px;
      text-align: center;
      line-height: 46px;
      margin-right: 30px;
      cursor: pointer;
      font-size: 18px;
      border-radius: 5px;
    }
    .active {
      background-color: #009edf;
      color: #ffffff;
      font-size: 20px;
    }
  }
  .p-match {
    width: 100%;
    background-color: #fbfbfb;
    min-height: 500px;
    border-top: 1px solid #e4e4e4;
    // 项目列表
    .pm-list {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: flex-start;
      padding-top: 30px;
      .pm-item {
        display: flex;
        justify-content: space-between;
        width: 380px;
        margin-bottom: 30px;
        margin-right: 30px;
        cursor: pointer;
        background-color: #cdd7e3;
        border-radius: 10px;
        position: relative;
        box-shadow: 20px 20rpx 20rpx 20px white;
        .pm-bg {
          width: 100px;
          height: 100px;
          background-color: #124584;
          border-radius: 10px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin-right: 10px;
          img {
            width: 60px;
            height: 60px;
            border-radius: 20px;
          }
          .name {
            font-size: 16px;
            color: white;
            font-weight: bold;
          }
        }
        .right {
          width: 270px;
          height: 100%;
          color: #666;
          padding-top: 6px;
          .address {
            overflow: hidden; //多出的隐藏
            text-overflow: ellipsis; //多出部分用...代替
            white-space: nowrap; //不换行
          }
          .title {
            width: 260px;
            min-height: 21px;
            font-weight: bold;
            overflow: hidden; //多出的隐藏
            text-overflow: ellipsis; //多出部分用...代替
            display: -webkit-box; //定义为盒子模型显示
            -webkit-line-clamp: 2; //用来限制在一个块元素显示的文本的行数
            -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
          }
        }
        .status {
          width: 100px;
          position: absolute;
          right: 0;
          bottom: -5px;
          font-size: 14px;
          .btn {
            position: relative;
            width: 80px;
            color: #fff;
            text-align: center;
            line-height: 30px;
            border-radius: 5px 0 0 5px;
            margin-left: 30px;
            margin-bottom: 10px;
            .arrows {
              position: absolute;
              right: 0;
              border: 5px solid #fff;
              border-bottom-color: transparent;
              border-right-color: transparent;
            }
          }
          .btn:hover {
            color: #eee;
            font-weight: bold;
          }
        }
      }
      /* 最后一项margin-right:auto */
      .pm-item:last-child {
        margin-right: auto;
      }
      .no-margin {
        margin-right: 0;
      }
    }
    //多个赛事
    .content {
      width: 1200px;
      margin: 0 auto;
      .back {
        display: flex;
        justify-content: flex-end;
        margin-top: 30px;
        .back-btn {
          width: 120px;
          background-color: #124584;
          height: 40px;
          line-height: 40px;
          color: #ffffff;
          text-align: center;
          border-radius: 5px;
          font-size: 16px;
          cursor: pointer;
        }
        .back-btn:hover {
          opacity: 0.8;
        }
      }
      .match-list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-top: 30px;
      }
    }
  }
  .empty {
    min-height: 400px;
    padding-top: 100px;
  }
}
</style>
vue



// WEBPACK FOOTER //
// src/district/views/project/Home.vue